function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import { InputGroup, Input, InputGroupAddon, Button } from 'reactstrap';
import clsx from 'clsx';
import { FiSearch } from 'react-icons/fi';
/**
 * Search input group
 *
 * @param String colorClass   Bootstrap color class
 * @param String inputLabel   Label for search input
 * @param String buttonLabel  Label for search button
 * @param Function handleSearch Handler for search button selected
 */

var Search = function Search(_ref) {
  var props = _extends({}, _ref); // console.log('Search')


  return /*#__PURE__*/React.createElement(InputGroup, {
    className: clsx('input-search', props.className)
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: props.placeholder,
    "aria-label": "inputLabel"
  }), /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React.createElement(Button, {
    color: props.colorClass,
    onClick: props.handleSearch,
    "aria-label": props.buttonLabel,
    className: "button-search"
  }, /*#__PURE__*/React.createElement(FiSearch, null))));
};

Search.defaultProps = {
  colorClass: "secondary",
  inputLabel: "Enter search criteria",
  buttonLabel: "Select to search",
  placeholder: "Search... ",
  handleSearch: null
};
export default Search;